import cn from "app/util/classnames";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "secondary" | "outline" | "white";
  className?: string;
  children: React.ReactNode;
}

export default function MenuButton({
  variant = "secondary",
  children,
  className,
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(
        "w-full max-w-40",
        "flex items-center justify-center",
        "rounded-sm px-1 py-2.5",
        "text-center",
        "cursor-pointer",
        {
          "border border-white bg-white text-black disabled:opacity-20":
            variant === "white",
          "bg-black text-white hover:text-yellow disabled:opacity-20 font-medium text-lg uppercase":
            variant === "secondary",
          "border border-black bg-transparent text-black":
            variant === "outline",
        },
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
